module.exports = __webpack_public_path__ + "static/img/our-customers-data-center-quote.0421dd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/our-customers-data-center-quote.jpg
// module id = AzV4
// module chunks = 0